import { render, staticRenderFns } from "./register-form.vue?vue&type=template&id=d62f1028&scoped=true&"
import script from "./register-form.vue?vue&type=script&lang=js&"
export * from "./register-form.vue?vue&type=script&lang=js&"
import style0 from "./register-form.vue?vue&type=style&index=0&id=d62f1028&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62f1028",
  null
  
)

export default component.exports